import React from 'react';
import { components } from 'react-select';
import OutdoorMatchedSearchtermLabel from './OutdoorMatchedSearchtermLabel';
import { style } from 'typestyle';
import { colours } from 'styling/colours';
type menuOptionsType = { value: string; key: string };

const OptionMenu: React.FC = (props: any) => {
  const {
    searchTerm,
    menuOptions,
    handleClickOptionSearch,
    optionText = 'for',
    title
  } = props;

  return (
    <div className="asyncSearch__menu-option-container">
      {title && <div className="dropdownMessage">{title}</div>}
      {menuOptions.map((option: menuOptionsType) => {
        return (
          <div
            role="button"
            className={OptionStyle}
            tabIndex={0}
            id={`category-select-option-${option.value}`}
            key={option.value}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleClickOptionSearch(e, option)
                e.stopPropagation();
              }
            }}
            onClick={(e) => handleClickOptionSearch(e, option)}
          >
            <components.Option {...props}>
              {option.value === 'is_outdoors' ? (
                <>
                  <b>{option.key}</b> is:{' '}
                  <OutdoorMatchedSearchtermLabel searchTerm={searchTerm} />
                </>
              ) : (
                <>
                  <b>{option.key}</b> {optionText}: {searchTerm}
                </>
              )}
            </components.Option>
          </div>
        );
      })}
    </div>
  );
};

export default OptionMenu;


const OptionStyle = style({
  color: colours.primaryText
})